import { useState, useEffect } from 'react';

export const useMovieData = (selectedDate, selectedCity) => {
    const [movies, setMovies] = useState([]);
    const [error, setError] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const fetchMovies = async (date, city) => {
        setIsLoading(true);
        try {
            const queryString = `?date=${date}&city=${city}`;
            const response = await fetch(`https://eventspire.nl/api/movies_with_cinemas/${queryString}`);

            if (!response.ok) {
                throw new Error(`Network response was not ok: ${response.statusText}`);
            }

            const data = await response.json();
            setMovies(data);
            setError(null);
        } catch (error) {
            setError(error);
            console.error("Fetch error:", error);
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchMovies(selectedDate, selectedCity);
    }, [selectedDate, selectedCity]);

    return { movies, error, isLoading };
};